import { TextField, DateField, Datagrid, List, useListController, BooleanField } from "react-admin";
import { dateOptions } from "../../../../utils/options";
import { PublishersExpand } from "../ListExpands/PublishersExpand";
import { DistrictsFirstReference } from "../ListExpands/DistrictPostOfficeExpand";
import { EmptyList } from "../../../../common/components";
import { reportDistrictsFirstSecondReferenceFilters, publishersEditionsFilters } from "../Filters";
import { DownloadTopToolbarButton } from "../../../../utils/customActions";
import { REPORT_AUTORS } from "../../Reports/ReportPublishers";
import { REPORT_DISCOUNT_POST_OFFICE } from "../../Reports/ReportDisPostOffice";

const PublishersFirstRef = ({ dpo, reportDpoOptions }) => {
  let url = !dpo ? `${REPORT_AUTORS}/download` : `${REPORT_DISCOUNT_POST_OFFICE}/download`;
  let fileName = !dpo ? "publishers-reference" : "districts-first-reference";
  const { filterValues, page, perPage } = useListController();
  return (
    <List
      actions={
        <DownloadTopToolbarButton
          customResources={url}
          fileName={fileName}
          filterParams={{ filterValues, page, perPage }}
        />
      }
      filters={reportDpoOptions ? reportDistrictsFirstSecondReferenceFilters : publishersEditionsFilters}
      filterDefaultValues={{ start_year: "2024" }}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
        expand={dpo ? <DistrictsFirstReference /> : <PublishersExpand />}
        expandSingle
      >
        <TextField
          label={dpo ? "ОПС" : "Издател"}
          source={dpo ? "district_post_office_name" : "publisher_name"}
          sortable={true}
        />
        {!dpo && (
          <TextField
            label="E-мейл на издателство"
            source="publisher_email"
            sortable={false}
          />
        )}
        {dpo && (
          <TextField
            label="ПК"
            source="post_code"
            sortable={true}
          />
        )}
        <TextField
          label="Издание"
          source="edition_name"
          sortable={true}
        />
        {!dpo && (
          <BooleanField
            label="Eл. Издание"
            source="is_edition_electronic"
            sortable={false}
          />
        )}
        <TextField
          label="Код"
          source="code"
          sortable={false}
        />

        <TextField
          label="Кат. №"
          source="catalog_number"
          sortable={true}
        />
        <TextField
          label="Име"
          source="receiver_first_name"
          sortable={true}
        />
        <TextField
          label="Фамилия"
          source="receiver_last_name"
          sortable={true}
        />
        <TextField
          label="Телефон"
          source="sender_phone"
          sortable={false}
        />
        <TextField
          label="E-мейл за доставка на ел изд."
          source="receiver_email"
          sortable={false}
        />

        <TextField
          label="Населено място"
          source="receiver_city"
          sortable={true}
        />
        <TextField
          label="Або. М."
          source="months_count"
          sortable={false}
        />
        <TextField
          label="Ед. цена евро"
          source="single_edition_price_euro"
          sortable={true}
        />

        <TextField
          label="Кол."
          source="editions_quantity"
          sortable={true}
        />
        <TextField
          label="Обща цена евро"
          source="sum_euro"
          sortable={true}
        />
        <DateField
          label="Начало на абонамента"
          source="campaign_start_date"
          sortable={false}
          locales={"bg"}
          options={dateOptions}
        />
      </Datagrid>
    </List>
  );
};
export default PublishersFirstRef;
